import type { ThemeConfig } from 'antd';

/** Above Ant Modal (1000) and the activity-center overlay (900). */
export const DMS_TOOLTIP_Z_INDEX = 1100;

export const dmsAntdTheme: ThemeConfig = {
  token: {
    colorPrimary: '#d40000',
    colorInfo: '#1677ff',
    colorSuccess: '#28a745',
    colorWarning: '#f59e0b',
    colorError: '#d40000',
    borderRadius: 4,
    fontFamily: 'var(--font-family, inherit)',
    fontSize: 14,
  },
  components: {
    Button: {
      borderRadius: 4,
      controlHeight: 32,
    },
    InputNumber: {
      borderRadius: 4,
      controlHeight: 32,
    },
    Modal: {
      borderRadiusLG: 4,
      titleFontSize: 20,
    },
    Table: {
      borderRadius: 4,
      cellFontSizeSM: 13,
      cellPaddingBlockSM: 6,
      cellPaddingInlineSM: 8,
      headerBg: '#f5f7f9',
      headerColor: '#2c3e50',
    },
  },
};
